<template>
    <v-container fluid>
         <v-row align="center" justify="center">
            <v-col cols="12" sm="10" lg="9" xl="7" class="d-flex flex-row flex-wrap justify-space-between align-center">
                <h1 class="platformName">{{ supportDashboardTitle }}</h1>
                <p class="platformSubtitle">{{ supportDashboardSubtitle }}</p>
            </v-col>
        </v-row>

        <v-row align="center" justify="center">
            <v-col cols="12" sm="10" lg="9" xl="7" class="d-flex flex-row flex-wrap justify-space-between align-center">

                <v-alert style="width: 100%" type="info" color="primary" v-if="supportDashboardNotification">
                    {{supportDashboardNotification}}
                </v-alert>

                <v-card class="DashboardCard">
                    <v-card-text>
                        <div class="DashboardVideo">
                            <div class="DashboardVideo__iFrameWrapper">
                                <div class="DashboardVideo__iFrame">
                                    <div :class="{jsVideoLoaded:!videoOverlay}" class="WistiaOverlay">
                                        <v-progress-circular color="primary" indeterminate/>
                                    </div>
                                    <iframe :onload="iframeLoaded()" :src="'https://fast.wistia.net/embed/iframe/' + supportDashboardWelcomeVideoEmbed"></iframe>
                                </div>
                            </div>
                        </div>
                        <div class="DashboardWelcomeText" v-html="supportDashboardWelcomeText"></div>
                        <div class="DashboardNavigationButtons">
                            <v-btn v-for="(item, index) in navigation"
                                   :key="index"
                                   color="secondary"
                                   :to="'/page/' + item.slug"
                            >
                                <v-icon small left>{{ item.icon }}</v-icon>
                                {{ item.name }}
                            </v-btn>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import store from '@/store/store';
import axios from 'axios';

export default {
    computed: {
        supportDashboardWelcomeVideoEmbed() {
            if (store.state.settings.settings['settingDashboardSupport']) {
                return store.state.settings.settings['settingDashboardSupport'].supportDashboardWelcomeVideoEmbed;
            } else {
                return '';
            }
        },

        supportDashboardWelcomeText() {
            if (store.state.settings.settings['settingDashboardSupport']) {
                return store.state.settings.settings['settingDashboardSupport'].supportDashboardWelcomeText;
            } else {
                return '';
            }
        },

        supportDashboardSubtitle() {
            if (store.state.settings.settings['settingDashboardSupport']) {
                return store.state.settings.settings['settingDashboardSupport'].supportDashboardSubtitle;
            } else {
                return '';
            }
        },

        supportDashboardTitle() {
            if (store.state.settings.settings['settingDashboardSupport']) {
                return store.state.settings.settings['settingDashboardSupport'].supportDashboardTitle;
            } else {
                return '';
            }
        },

        supportDashboardNotification() {
            if (store.state.settings.settings['settingDashboardSupport']) {
                return store.state.settings.settings['settingDashboardSupport'].supportDashboardNotification;
            } else {
                return '';
            }
        },

        supportDashboardButton1() {
            if (store.state.settings.settings['settingDashboardSupport']) {
                return store.state.settings.settings['settingDashboardSupport'].button1;
            } else {
                return '';
            }
        },

        supportDashboardButton2() {
            if (store.state.settings.settings['settingDashboardSupport']) {
                return store.state.settings.settings['settingDashboardSupport'].button2;
            } else {
                return '';
            }
        },

        supportDashboardButton3() {
            if (store.state.settings.settings['settingDashboardSupport']) {
                return store.state.settings.settings['settingDashboardSupport'].button3;
            } else {
                return '';
            }
        },

        supportDashboardButton4() {
            if (store.state.settings.settings['settingDashboardSupport']) {
                return store.state.settings.settings['settingDashboardSupport'].button4;
            } else {
                return '';
            }
        },
    },

    data() {
        return {
            loading: true,
            navigation: false,
            allNavItems: [],
            videoOverlay: true,
        };
    },

    mounted() {
        this.getAllNavItems();
    },

    methods: {
        getAllNavItems() {
            return new Promise((resolve) => {
                axios.get('/api/navigation-link/index')
                    .then(response => {
                        this.allNavItems = response.data.data.navigationLinks.links;
                        this.setNavItems();
                        resolve();
                    })
                    .catch(error => {
                        console.error(error);
                        resolve();
                    });
            });
        },

        setNavItems() {
            let newNavItems = [];
            let navItemsForPage = [
                this.supportDashboardButton1.navItem,
                this.supportDashboardButton2.navItem,
                this.supportDashboardButton3.navItem,
                this.supportDashboardButton4.navItem,
            ];

            navItemsForPage.forEach(item => {
                const link = this.allNavItems.find(i => i.id === item);

                newNavItems.push({
                    'name': link.name,
                    'icon': link.icon,
                    'slug': link.page.slug
                });
            });

            this.navigation = newNavItems;
        },

        iframeLoaded() {
            setTimeout(()=>{
                this.videoOverlay = false;
            }, 1000);
        }
    }
};
</script>
<style lang="scss">
.DashboardCard {
    flex: 0 0 100%;
    width: 100%;

    @media (min-width: 768px) {
        padding: 24px;
    }

    @media (min-width: 1200px) {
        padding: 48px;
    }

    .v-input__control {
        margin-bottom: 0;
    }

    .v-text-field__details, {
        display: none !important;
    }
}

.DashboardWelcomeText {
    flex: 0 0 100%;
    width: 100%;
    margin-bottom: 24px;
    font-size: 1.02rem;
}

.DashboardNavigationButtons {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    @media( min-width: 1200px) {
        flex-flow: row nowrap;
    }

    .v-btn {
        flex: 0 0 100%;
        width: 100%;
        margin-bottom: 12px !important;

        @media (min-width: 1200px) {
            flex: 1 1 32%;
            width: 32%;
            margin-bottom: 0 !important;
            margin-right: 12px;

            &:last-of-type {
                margin-right: 0;
            }
        }
    }
}

</style>
